(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:RecomendacoesSemeaduraCtrl
   * @description
   * # RecomendacoesSemeaduraCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('RecomendacoesSemeaduraNewCtrl', RecomendacoesSemeaduraController);

  /**
   * RecomendacoesSemeaduraController dependencies
   * @type {Array}
   */
  RecomendacoesSemeaduraController.$inject = [
    '$scope',
    '$rootScope',
    '$location',
    'Flash',
    'LoadingService',
    'RecomendacoesSemeaduraService',
    'RecomendacoesSemeaduraObjectService',
    'MessagesService',
    'SafrasService'
  ];

  /**
   * RecomendacoesSemeaduraController declaration
   */
  // eslint-disable-next-line max-lines-per-function, max-params
  function RecomendacoesSemeaduraController($scope, $rootScope, $location, Flash, LoadingService,
    RecomendacoesSemeaduraService, RecomendacoesSemeaduraObjectService, MessagesService, SafrasService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.filters = {
      safra: null,
      status: null,
      page: 1
    };
    vm.safras = [];
    vm.recommendations = [];

    //////////////////////////////////////////
    // Bindable methods
    vm.loadList = LoadList;
    vm.confirmDelete = ConfirmDelete;
    vm.loadStatus = LoadStatus;
    vm.percentWidth = PercentWidth;
    vm.showDetailsBtn = ShowDetailsBtn;

    //////////////////////////////////////////
    // Function declarations

    function LoadList() {
      LoadingService.showLoading();

      vm.recommendations.length = 0;

      RecomendacoesSemeaduraService.list(vm.filters).then(function(response) {
        vm.recommendations = response.data.map(function(rec) {
          return RecomendacoesSemeaduraObjectService.convertToObject(rec);
        });

        $scope.pages = response.pages || {};

        LoadingService.hideLoading();
      }, $rootScope.errorRootInitialize);
    }

    function ConfirmDelete(recommendation) {
      MessagesService.confirm('Deseja excluir a recomendação?').then(function() {
        LoadingService.showLoading();

        RecomendacoesSemeaduraService.delete(recommendation.id).then(function() {
          MessagesService.alert('Recomendação excluída com sucesso.');
          vm.loadList();
        // eslint-disable-next-line newline-per-chained-call
        }).catch(function() {
          MessagesService.alert('Erro ao excluir a recomendação, tente novamente.');
        });
      // eslint-disable-next-line newline-per-chained-call, no-empty-function
      }).catch(function() {});
    }

    function LoadStatus(rec) {
      rec.loading = true;
      RecomendacoesSemeaduraService.status(rec.id).then(function(response) {
        rec.loading = false;
        rec.progress = response.data;
      });
    }

    function PercentWidth(percentual) {
      return {
        width: `${percentual * 100}%`
      };
    }

    function ShowDetailsBtn(rec) {
      return !rec.progress && !rec.loading && rec.situacao.toLowerCase() === 'em_andamento';
    }

    //////////////////////////////////////////
    // Controller logic

    // show loading screen
    LoadingService.showLoading();

    $rootScope.initialize.then(function() {
      // redirects to home if unallowed
      if (!$rootScope.permissions.recomendacaoSemeadura.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
      } else {
        SafrasService.listAll().then(function(result) {
          vm.safras = result.data;
          vm.safras.forEach(function(safra) {
            if (safra.current) {
              vm.filters.safra = safra;
            }
          });

          vm.loadList();
          // eslint-disable-next-line newline-per-chained-call
        }).catch(function(error) {
          console.error('Falha ao carregar safras', error);
          $rootScope.errorRootInitialize();
        });
      }
    }, $rootScope.errorRootInitialize);
  }
}());
